<template>
  <div class="card shadow-sm p-3 mb-3">
    <div class="row g-2">
      <div class="col-md-2">
        <label class="form-label small">Start Date</label>
        <input
          v-model="localFilters.startDate"
          type="date"
          class="form-control form-control-sm"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label small">End Date</label>
        <input
          v-model="localFilters.endDate"
          type="date"
          class="form-control form-control-sm"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label small">Device ID</label>
        <select
          v-model="localFilters.deviceId"
          class="form-select form-select-sm"
        >
          <option value="">Any</option>
          <option v-for="device in devices" :key="device.id" :value="device.id">
            {{ device.name }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label small">UNIC ID</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="localFilters.unicId"
          placeholder="Search by UNIC ID"
        />
      </div>
      <div class="col-md-2">
        <label class="form-label small">Sort By</label>
        <select v-model="localFilters.sort" class="form-select form-select-sm">
          <option value="print_time|desc">Print Time (Newest First)</option>
          <option value="print_time|asc">Print Time (Oldest First)</option>
          <option value="capture_time|desc">Capture Time (Newest First)</option>
          <option value="capture_time|asc">Capture Time (Oldest First)</option>
          <option value="price|desc">Price (High to Low)</option>
          <option value="price|asc">Price (Low to High)</option>
          <option value="coin_type|desc">Payment type (A to Z)</option>
          <option value="coin_type|asc">Payment type (Z to A)</option>
        </select>
      </div>
      <div class="col-md-2 d-flex align-items-end justify-content-start">
        <button class="btn btn-warning btn-sm px-5" @click="applyFilters">
          Apply
        </button>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-3 mt-2">
      <div class="form-check" v-for="(label, key) in checkboxMap" :key="key">
        <input
          class="form-check-input"
          type="checkbox"
          :id="key"
          v-model="localFilters[key]"
        />
        <label class="form-check-label small" :for="key">{{ label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhotoFilters",
  props: {
    filters: Object,
    devices: Object,
  },
  emits: ["update:filters"],
  data() {
    return {
      localFilters: {
        sort: "print_time|desc",
        ...this.filters,
      },
      checkboxMap: {
        userPhotos: "User photos",
        testPhotos: "Test photos",
        colored: "Colored",
        bw: "B/W",
        coin_0: "Unknown / Free",
        coin_1: "Coin",
        coin_2: "Cash",
        coin_3: "Card",
      },
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(newFilters) {
        this.localFilters = {
          sort: "print_time|desc",
          ...newFilters,
        };
      },
    },
  },
  methods: {
    applyFilters() {
      this.$emit("update:filters", { ...this.localFilters });
    },
  },
};
</script>
